/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Invariant_OpenInputs */

const en_sch_err_invariant_open = /** @type {(inputs: Sch_Err_Invariant_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workflow needs at least one status in Backlog or Unstarted, where new work starts.`)
};

const de_sch_err_invariant_open = /** @type {(inputs: Sch_Err_Invariant_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Workflow braucht mindestens einen Status in Backlog oder Nicht begonnen, wo neue Arbeit beginnt.`)
};

/**
* | output |
* | --- |
* | "A workflow needs at least one status in Backlog or Unstarted, where new work starts." |
*
* @param {Sch_Err_Invariant_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_invariant_open = /** @type {((inputs?: Sch_Err_Invariant_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Invariant_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_invariant_open(inputs)
	return en_sch_err_invariant_open(inputs)
});